import React from "react";
import Modal from "../../../shared/ui/Modal";

import { useItemForm } from "../model/ItemFormContext";
import { parseMyCompareItemId } from "./parseMyCompareItemId";

interface Props {
    show: boolean;
    onHide: () => void;
}

const MyCompareItemIdByUrlModal: React.FC<Props> = ({ show, onHide }) => {
    const { watch, setValue, trigger } = useItemForm();
    const compareSite = watch("compare_site");

    const [itemUrl, setItemUrl] = React.useState("");
    const [memo, setMemo] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");

    const getCompareSiteLabel = () => {
        if (compareSite === "naver") {
            return "네이버";
        }
        if (compareSite === "danawa") {
            return "다나와";
        }
        if (compareSite === "enuri") {
            return "에누리";
        }
        return "";
    };

    const handleClose = () => {
        setItemUrl("");
        setMemo("");
        setErrorMessage("");
        onHide();
    };

    const handleConfirm = async () => {
        setErrorMessage("");

        const trimmedUrl = itemUrl.trim();
        if (!trimmedUrl) {
            setErrorMessage("내 상품 URL을 입력하세요.");
            return;
        }

        try {
            const myCompareItemId = parseMyCompareItemId(trimmedUrl, compareSite);
            setValue("my_compare_item_id", myCompareItemId, {
                shouldValidate: true,
            });
            setValue("my_compare_item", {
                item_id: myCompareItemId,
                item_url: trimmedUrl,
                memo: memo.trim(),
            });
            await trigger("my_compare_item_id");
            handleClose();
        } catch (error: any) {
            setErrorMessage(error?.message || "URL 처리 중 오류가 발생했습니다.");
        }
    };

    React.useEffect(() => {
        if (!show) {
            return;
        }
        setItemUrl("");
        setMemo("");
        setErrorMessage("");
    }, [show]);

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="fs-5">내 상품 URL로 지정</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row mb-2">
                    <div className="col">
                        <select className="form-control" disabled>
                            <option>{getCompareSiteLabel()}</option>
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="내 상품 URL을 입력하세요"
                            value={itemUrl}
                            onChange={(e) => setItemUrl(e.target.value)}
                        />
                    </div>
                </div>
                <input
                    type="text"
                    className="form-control mt-2"
                    aria-label="상품 메모"
                    placeholder="메모 (선택)"
                    value={memo}
                    onChange={(e) => setMemo(e.target.value)}
                />

                {errorMessage && (
                    <div
                        className="alert alert-danger alert-dismissible fade show mt-3"
                        role="alert"
                    >
                        {errorMessage}
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setErrorMessage("")}
                        ></button>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-primary" onClick={handleConfirm}>
                    확인
                </button>
                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                    취소
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default MyCompareItemIdByUrlModal;
